import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container, Alert, Card } from 'react-bootstrap';
import OuvidoriaService from '../../../../services/ouvidoria-auth';
import { Navigate, useParams, useNavigate } from 'react-router-dom';



const FormStatus = () => {
    const [situacao, setSituacao] = useState("");
    const [sucesso, setSucesso] = useState(false);
    const [conteudo, setConteudo] = useState("");
    const [anexoTipo, setAnexoTipo] = useState(false);
    const [prorrogacao, setProrrogacao] = useState(false);
    const [prorrogado, setProrrogado] = useState(false);
    const [sigilo, setSigilo] = useState(false);
    const [desclassificada, setDesclassificada] = useState(null);
    const [grauSigilo, setGrauSigilo] = useState(null);
    const [justificativa, setJustificativa] = useState(false);
    const [respostas, setRespostas] = useState([]);
    const [anexo, setAnexo] = useState([]);
    const [link, setLink] = useState([]);
    const [error, setError] = useState([]);
    const { id } = useParams();

    const handleUpload = (e) => setAnexo(e.target.files[0]);

    const navigate = useNavigate();

    const voltarPaginaAnterior = () => {
        navigate(-1);
    };

    async function fetchRequisicao(id) {
        const response = await OuvidoriaService.ouvidEdit(id);
        setSituacao(response.data["situacao"]);
        setRespostas(response.data["respostas"]);
        response.data["prorrogado"] ? setProrrogado(true) : setProrrogado(false)
        response.data["sigilo"] ? setSigilo(true) : setSigilo(false)
        response.data["desclassificada"] ? setDesclassificada(true) : setDesclassificada(false)
        response.data["justificativa"] ? setJustificativa(response.data["justificativa"]) : setJustificativa(null)
        response.data["grauSigilo"] ? setGrauSigilo(response.data["grauSigilo"]) : setGrauSigilo(null)
    }

    useEffect(() => {
        fetchRequisicao(id);
    }, [id]);


    const montaForm = async () => {
        const ouvidoria = new FormData();
        ouvidoria.append("situacao", situacao)
        ouvidoria.append("conteudo", conteudo)
        ouvidoria.append("anexo", anexo);
        if (prorrogacao == "true") {
            ouvidoria.append("prorrogado", prorrogacao);
        }
        if (sigilo == "true") {
            ouvidoria.append("sigilo", true);
            ouvidoria.append("justificativa", justificativa);
            ouvidoria.append("grauSigilo", grauSigilo);
        }
        if (desclassificada == "true") {
            ouvidoria.append("desclassificada", true);
        }
        ouvidoria.append("link", link);
        return ouvidoria
    }

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        const dados = await montaForm();
        try {
            const ouvidoria = await OuvidoriaService.editar(id, dados);
            alert("Situação atualizada com sucesso!")
            setSucesso(true)
            setError(false)
        } catch (error) {
            setError(error)
        }
    }
    if (!sucesso) {
        return (
            <Fragment>
                <Container>
                    <Card className="card-list">
                        <Card.Header><h5>Requisição: {id} | Situação: {situacao}</h5></Card.Header>
                        <Card.Body>
                            {prorrogado ? <Alert variant="danger">
                                Essa requisição já sofreu pedido de prorrogação de prazo de resposta!
                            </Alert> : null} <br />
                            <h4>Histórico de mensagens (últimas respostas primeiro):</h4>
                            {respostas.slice().reverse().map((resposta) =>
                                <Fragment>
                                    <p><strong>{resposta.quem} respondeu:</strong></p>
                                    <p>{resposta.conteudo}</p>
                                    {resposta.anexo ? <a href={resposta.anexo} target="_blank">Anexo</a> : ''}
                                    <hr />
                                </Fragment>
                            )}
                        </Card.Body>
                    </Card>
                    <div className="da-espaco">
                        <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                            <Row xs={1} lg={3}>
                                <Col xs={12}>
                                    <Form.Group className="mb-3" controlId="situacao">
                                        <FloatingLabel
                                            label="Situação"
                                            className="mb-3"
                                        >
                                            <Form.Select
                                                required
                                                aria-label="situacao"
                                                name="situacao"
                                                onChange={e => setSituacao(e.target.value)}
                                            >
                                                <option value={situacao}>{situacao}</option>
                                                <option value="Pendente">Pendente</option>
                                                <option value="Recebido pela Prefeitura">Recebido pela Prefeitura</option>
                                                <option value="Encaminhada à Secretaria Responsável">Encaminhada à Secretaria Responsável</option>
                                                <option value="Secretaria Responsável está atuando">Secretaria Responsável está atuando</option>
                                                <option value="Respondido">Respondido</option>
                                                <option value="Resolvido">Resolvido</option>
                                                <option value="1º Recurso">1º Recurso</option>
                                                <option value="2º Recurso">2º Recurso</option>
                                                <option value="Último Recurso">Último Recurso</option>
                                                <option value="Encaminhado à Autoridade Superior">Encaminhado à Autoridade Superior</option>
                                                <option value="Encerrado">Encerrado</option>
                                                <option value="Indeferido, justificado via mensagem">Indeferido, justificado via mensagem</option>
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={12}>
                                    <Form.Group className="mb-3" controlId="Resposta">
                                        <FloatingLabel
                                            label="Resposta do órgão"
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                type="text"
                                                name="conteudo"
                                                value={conteudo}
                                                onChange={e => setConteudo(e.target.value)}
                                                as="textarea"
                                                rows={10}
                                            />
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                <br />
                                {!prorrogado ?
                                    <Col xs={12} lg={3}>
                                        <Form.Group className="mb-3" controlId="anexoTipo">
                                            <FloatingLabel
                                                label="Pedir Prorrogação?"
                                                className="mb-3"
                                            >
                                                <Form.Select
                                                    required
                                                    name="prorrogacao"
                                                    onChange={e => setProrrogacao(e.target.value)}
                                                >
                                                    <option value="false">Não</option>
                                                    <option value="true">Sim</option>
                                                </Form.Select>
                                            </FloatingLabel>
                                        </Form.Group>
                                    </Col> : null}
                                <Col xs={12} lg={3}>
                                    <Form.Group className="mb-3" controlId="anexoTipo">
                                        <FloatingLabel
                                            label="Informação Sigilosa?"
                                            className="mb-3"
                                        >
                                            <Form.Select
                                                required
                                                name="sigilo"
                                                onChange={e => setSigilo(e.target.value)}
                                            >
                                                <option value={sigilo}>{sigilo === true || sigilo === "true" ? "Sim" : "Não"}</option>
                                                <option value="false">Não</option>
                                                <option value="true">Sim</option>
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={3}>
                                    <Form.Group className="mb-3" controlId="anexoTipo">
                                        <FloatingLabel
                                            label="Informação Desclassificada?"
                                            className="mb-3"
                                        >
                                            <Form.Select
                                                required
                                                name="desclassificada"
                                                onChange={e => setDesclassificada(e.target.value)}
                                            >
                                                <option value={desclassificada}>{desclassificada === true || desclassificada === "true" ? "Sim" : "Não"}</option>
                                                <option value="false">Não</option>
                                                <option value="true">Sim</option>
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                {sigilo === "true" || sigilo === true ?
                                    <Fragment>
                                        <Col xs={12} lg={4}>
                                            <Form.Group className="mb-3" controlId="anexoTipo">
                                                <FloatingLabel
                                                    label="Grau do Sigilo"
                                                    className="mb-3"
                                                >
                                                    <Form.Select
                                                        required
                                                        name="sigilo"
                                                        onChange={e => setGrauSigilo(e.target.value)}
                                                    >
                                                        <option value={grauSigilo}>{grauSigilo != null ? grauSigilo : null}</option>
                                                        <option value="Reservadas">Reservadas</option>
                                                        <option value="Secretas">Secretas</option>
                                                        <option value="Ultrasecretas">Ultrasecretas</option>
                                                    </Form.Select>
                                                </FloatingLabel>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} lg={12}>
                                            <Form.Group className="mb-3" controlId="Resposta">
                                                <FloatingLabel
                                                    label="Justificativa legal do sigilo"
                                                    className="mb-3"
                                                >
                                                    <Form.Control
                                                        type="text"
                                                        name="justificativa"
                                                        value={justificativa}
                                                        onChange={e => setJustificativa(e.target.value)}
                                                        as="textarea"
                                                        rows={10}
                                                    />
                                                </FloatingLabel>
                                            </Form.Group>
                                        </Col>
                                    </Fragment> : null}
                                <Col xs={12} lg={6}>
                                    <Form.Group className="mb-3" controlId="anexoTipo">
                                        <Form.Label>Tipo de Anexo</Form.Label>
                                        <Form.Select
                                            required
                                            name="anexoTipo"
                                            onChange={e => setAnexoTipo(e.target.value)}
                                        >
                                            <option>Nenhum</option>
                                            <option value="link">Link</option>
                                            <option value="documento">Documento</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                {anexoTipo ?
                                    <Col xs={12} lg={6}>
                                        <Form.Group className="mb-3" controlId="anexo">
                                            <Form.Label>{anexoTipo === "link" ? "Link" : "Documento"}</Form.Label>
                                            {anexoTipo === "link" ? (
                                                <Form.Control
                                                    type="text"
                                                    name="link"
                                                    value={link}
                                                    onChange={e => setLink(e.target.value)}
                                                />
                                            ) : (
                                                <Fragment>
                                                    <Form.Control
                                                        type="file"
                                                        name="anexo"
                                                        onChange={handleUpload}
                                                        accept=".pdf, .xlsx, .xls"
                                                    />
                                                </Fragment>
                                            )}
                                        </Form.Group>
                                    </Col> : ''}
                                {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                            </Row>
                            <Col xs={12} lg={2}>
                                <Button type='submit' variant='primary'>Atualizar Requisição</Button>
                            </Col>
                        </Form>
                        <br />
                        <Button variant="danger" onClick={voltarPaginaAnterior} type="button">
                            Cancelar
                        </Button>
                    </div>
                </Container>
            </Fragment>
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Resposta enviada com sucesso!</Alert>
                <Button variant="primary" onClick={voltarPaginaAnterior} type="button">
                            Voltar para listagem
                        </Button>
            </Fragment>
        )
    }
}

export default FormStatus